<template>
    <div class="flex w-full flex-col items-center justify-center px-4 py-6">
        <!-- Custom message (if provided) -->
        <div
            v-if="message"
            class="prose prose-sm mb-4 max-w-md text-center"
            v-html="message"
        />

        <div class="w-full max-w-md">
            <form
                class="flex w-full items-center gap-2"
                @submit.prevent="handleSubmit"
            >
                <DInput
                    v-model="password"
                    type="password"
                    placeholder="Enter password"
                    size="md"
                    :disabled="isAuthorizing"
                    right-icon="ph:lock-simple"
                    class="flex-1"
                />

                <DButton
                    type="submit"
                    theme="brand"
                    size="md"
                    :disabled="!password"
                    :loading="isAuthorizing"
                >
                    Unlock
                </DButton>
            </form>

            <p
                v-if="displayError"
                class="mt-2 text-center text-xs text-red-600"
            >
                {{ displayError }}
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { DButton, DInput } from '@digistorm/spark'

    const props = defineProps<{
        isProtected?: boolean
        isAuthorized?: boolean
        requiresToken?: boolean
        gateUid?: string
        gateType?: string
        gateName?: string
        message?: string | null
        entryTitle?: string
    }>()

    const emit = defineEmits<{
        (e: 'authorized', gateUid: string): void
    }>()

    const password = ref('')
    const localError = ref('')
    const { authorise, isAuthorizing, authError } = useProtectedContent()

    const displayError = computed(() => localError.value || authError.value)

    const handleSubmit = async () => {
        localError.value = ''

        const gateUid = props.gateUid
        if (!gateUid) {
            localError.value = 'Protected content gate is unavailable'
            return
        }

        const success = await authorise(gateUid, password.value)

        if (success) {
            password.value = ''
            emit('authorized', gateUid)
        }
    }
</script>
